import React from 'react';
import { useSelector } from 'react-redux';
import DriversAgeCheckbox from './DriversAgeCheckbox';
import DriversAgeInput from './DriversAgeInput';

import DriversAgeInfoModal from './DriversAgeInfoModal';
import { getIsDriversAgeWithinRange } from '../../../selectors/filtersSelectors';

const DriversAge = () => {
  const isDriversAgeWithinRange = useSelector(getIsDriversAgeWithinRange);

  return (
    <div className="col-xs-12 margin-1-b-sm-down pad-t">
      <div className="flex flex-align-center flex-align-start">
        <DriversAgeCheckbox />
        <DriversAgeInfoModal />
      </div>
      {!isDriversAgeWithinRange && (
      <DriversAgeInput />
      )}
    </div>
  );
};

export default DriversAge;
